import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BASE}/api`;

const portalApi = axios.create({ baseURL: API_URL });

let portalToken = sessionStorage.getItem("portal_token") || null;

export const setPortalToken = (t) => {
  portalToken = t;
  if (t) sessionStorage.setItem("portal_token", t);
  else sessionStorage.removeItem("portal_token");
};

export const getPortalToken = () => portalToken;

portalApi.interceptors.request.use((config) => {
  if (portalToken) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${portalToken}`;
  }
  return config;
});

export const formatErr = (err) => {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
};

export const portalFileUrl = (path) =>
  `${API_URL}${path}?auth=${encodeURIComponent(portalToken || "")}`;

export const portalLogoUrl = () => `${API_URL}/portal/branding/logo`;

export default portalApi;
